import { render, staticRenderFns } from "./ShipmentCreationRules.vue?vue&type=template&id=4896c4be"
import script from "./ShipmentCreationRules.vue?vue&type=script&lang=js"
export * from "./ShipmentCreationRules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports